module.exports = __webpack_public_path__ + "static/media/avatar.76654c1c.png";